/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FabrikatDto as OkEgisServiceModelsDtoFabrikatDto } from '../models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ProduktEnum as OkEgisServiceModelsEntitiesEnumsProduktEnum } from '../models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';

@Injectable({
  providedIn: 'root',
})
export class FabrikatService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getFabrikater
   */
  static readonly GetFabrikaterPath = '/api/v1/Fabrikat/GetFabrikater';

  /**
   * Returns a list of fabrikater.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFabrikater()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFabrikater$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FabrikatService.GetFabrikaterPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>;
      })
    );
  }

  /**
   * Returns a list of fabrikater.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFabrikater$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFabrikater(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoFabrikatDto>> {

    return this.getFabrikater$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>) => r.body as Array<OkEgisServiceModelsDtoFabrikatDto>)
    );
  }

  /**
   * Path part for operation getFabrikaterForProdukt
   */
  static readonly GetFabrikaterForProduktPath = '/api/v1/Fabrikat/GetFabrikaterForProdukt';

  /**
   * Returns a list of fabrikater.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFabrikaterForProdukt()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFabrikaterForProdukt$Response(params: {
    produktId?: OkEgisServiceModelsEntitiesEnumsProduktEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FabrikatService.GetFabrikaterForProduktPath, 'get');
    if (params) {
      rb.query('produktId', params.produktId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>;
      })
    );
  }

  /**
   * Returns a list of fabrikater.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFabrikaterForProdukt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFabrikaterForProdukt(params: {
    produktId?: OkEgisServiceModelsEntitiesEnumsProduktEnum;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoFabrikatDto>> {

    return this.getFabrikaterForProdukt$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoFabrikatDto>>) => r.body as Array<OkEgisServiceModelsDtoFabrikatDto>)
    );
  }

  /**
   * Path part for operation createFabrikat
   */
  static readonly CreateFabrikatPath = '/api/v1/Fabrikat';

  /**
   * Creates a Fabrik.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFabrikat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFabrikat$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFabrikatDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>> {

    const rb = new RequestBuilder(this.rootUrl, FabrikatService.CreateFabrikatPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>;
      })
    );
  }

  /**
   * Creates a Fabrik.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFabrikat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFabrikat(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFabrikatDto
  }): Observable<OkEgisServiceModelsDtoFabrikatDto> {

    return this.createFabrikat$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>) => r.body as OkEgisServiceModelsDtoFabrikatDto)
    );
  }

  /**
   * Path part for operation updateFabrikat
   */
  static readonly UpdateFabrikatPath = '/api/v1/Fabrikat/{fabrikatId}';

  /**
   * Updates a Fabrik.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFabrikat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFabrikat$Response(params: {
    fabrikatId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFabrikatDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>> {

    const rb = new RequestBuilder(this.rootUrl, FabrikatService.UpdateFabrikatPath, 'put');
    if (params) {
      rb.path('fabrikatId', params.fabrikatId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>;
      })
    );
  }

  /**
   * Updates a Fabrik.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFabrikat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFabrikat(params: {
    fabrikatId: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoFabrikatDto
  }): Observable<OkEgisServiceModelsDtoFabrikatDto> {

    return this.updateFabrikat$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoFabrikatDto>) => r.body as OkEgisServiceModelsDtoFabrikatDto)
    );
  }

}
